import FooterContentButton from './footer-content-button';
import FooterToggleButton from './footer-toggle-button';
import FooterBar from './footerbar';

export { FooterBar, FooterContentButton, FooterToggleButton };

export default {
  FooterToggleButton,
  FooterContentButton,
  FooterBar
};
